import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import { useDispatch } from "react-redux";
import { logOut } from "../../store/auth/authActions";

interface IProps {
  rootClass: any;
  textClass: any;
}

const LogoutButton: React.FC<IProps> = ({ rootClass, textClass }) => {
  const dispatch = useDispatch();

  return (
    <Link onClick={() => dispatch(logOut())} component={"li"} style={{ textDecoration: "none" }}>
      <ListItem button classes={{ root: rootClass }}>
        <ListItemText classes={{ primary: textClass }} primary={"Wyloguj"} />
      </ListItem>
      <Divider />
    </Link>
  );
};

export default LogoutButton;
